var map = {
	"./bed.svg": "cd7c",
	"./facilities.svg": "b456",
	"./food&drink.svg": "a702",
	"./food.svg": "2e6a",
	"./guide.svg": "0e8a",
	"./media_gallery.svg": "dcd4",
	"./meeting&event.svg": "1819",
	"./menu.svg": "dee0",
	"./offer.svg": "4d88",
	"./package.svg": "088a",
	"./pool.svg": "9f5d",
	"./promo-code.svg": "ca176",
	"./promotion.svg": "e252",
	"./review(1).svg": "2f8e",
	"./review.svg": "2575",
	"./services.svg": "4b6f",
	"./social.svg": "1562",
	"./stay.svg": "3cd3",
	"./voucher.svg": "2d6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a841";